(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() { super(); }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';

      this.headerBounds = {};

      this.setHeaderHeight();
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      const observer = new IntersectionObserver((entries, obs) => {
        this.headerBounds = entries[0].intersectionRect;
        obs.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  /* Original */

  (function () {
    const VAR_STICKY = '--sticky-header-height';
    const VAR_VH = '--viewport-height';
    const VAR_VH_WITHOUT = '--viewport-height-without-sticky-header';
    const VAR_STICKY_POS_FIXED = '--sticky-header-position-fixed';

    function updateVars() {
      const headerEl = document.querySelector('header.header');
      const viewportHeight = window.innerHeight;
      document.documentElement.style.setProperty(VAR_VH, `${viewportHeight}px`);
      const headerGroupEl = document.querySelector('.section-header');      
      if (headerGroupEl) {
        const groupRect = headerGroupEl.getBoundingClientRect();
        document.documentElement.style.setProperty(
          VAR_STICKY_POS_FIXED,
          `${Math.round(groupRect.top)}px`
        );
      } else {
        document.documentElement.style.setProperty(VAR_STICKY_POS_FIXED, `0px`);
      }

      if (!headerEl) {
        document.documentElement.style.setProperty(VAR_STICKY, `0px`);
        document.documentElement.style.setProperty(VAR_VH_WITHOUT, `${viewportHeight}px`);
        return;
      }

      const rect = headerEl.getBoundingClientRect();
      const stickyHeight = rect.top + rect.height;
      const stickyPx = Math.round(stickyHeight);
      const withoutSticky = Math.round(viewportHeight - stickyHeight);
      document.documentElement.style.setProperty(VAR_STICKY, `${stickyPx}px`);
      document.documentElement.style.setProperty(VAR_VH_WITHOUT, `${withoutSticky}px`);
    }

    function updateTouchTopClass() {
      const atTop = (window.pageYOffset || document.documentElement.scrollTop || 0) <= 0;
      document.body.classList.toggle('touch-top', atTop);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        updateVars();
        updateTouchTopClass();
      });
    } else {
      updateVars();
      updateTouchTopClass();
    }

    window.addEventListener('scroll', function () {
      updateVars();
      updateTouchTopClass();
    }, { passive: true });

    window.addEventListener('resize', function () {
      updateVars();
      updateTouchTopClass();
    });

    window.addEventListener('load', function () {
      updateVars();
      updateTouchTopClass();
    });

    const headerEl = document.querySelector('header.header');
    if (headerEl && 'ResizeObserver' in window) {
      const ro = new ResizeObserver(updateVars);
      ro.observe(headerEl);
    }
  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-faq"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded',function(){
  const dls = document.getElementsByClassName("faq-list");
  for (var i = 0, len = dls.length; i < len; i++) {
    let dt = dls[i].firstElementChild
    let dd = dls[i].lastElementChild
    dt.addEventListener("click", e => {
      let hei = dd.firstElementChild.offsetHeight;
      if(dt.classList.contains("open")){
        dt.classList.remove("open");
        dd.style.height = 0 + 'px';
      }else{
        dt.classList.add("open");
        dd.style.height = hei + 'px';
      }
    })
  }
  window.addEventListener("resize",()=>{
    for (var j = 0, len = dls.length; j < len; j++) {
      if(dls[j].lastElementChild.hasAttribute("style")){
        dls[j].firstElementChild.classList.remove("open");
        dls[j].lastElementChild.removeAttribute('style');
      }
    }
  }, false);
});

  } catch(e) { console.error(e); }
})();
})();
